import { Chip } from '@mui/material';
import dayjs from '../utils/format';
import { useNow } from '../hooks/useNow';

interface EventStatusChipProps {
    /** Data e ora di inizio dell'evento (ISO dal server). */
    eventDate: string;
    /** Classi del chiamante per il posizionamento (es. overlay sulla card). */
    className?: string;
}

/**
 * Chip "Iniziato": visibile solo quando l'evento è già iniziato.
 *
 * Il confronto usa `dayjs(event_date)` senza conversione di fuso, la stessa
 * interpretazione di `formatTime`: così il chip è coerente con l'orario mostrato.
 * La durata è una variabile del server (non esposta al client), quindi il chip
 * non sa quando l'evento finisce e resta visibile dopo l'inizio.
 */
export function EventStatusChip({ eventDate, className }: EventStatusChipProps) {
    const now = useNow();
    const started = dayjs(eventDate).valueOf() <= now;
    if (!started) return null;

    return <Chip label="Iniziato" color="primary" size="small" className={className} sx={{ fontWeight: 800 }} />;
}
